import { PropertyApiService } from '@admin/core';
import { LocationEntity } from '@admin/core/models/location.model';
import { PropertyEntity } from '@admin/core/models/property.model';
import { TagStatus } from '@admin/core/models/types.model';
import { TagStatusValues } from '@admin/shared/data/static.data';
import { getLabel, isChangingTagStatusValid } from '@admin/shared/helpers';
import { formControl } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonClickEvent, CacBaseDialogComponent, CacDialogLayoutComponent, CacControlBuilderComponent, FormBuilderInputOption } from '@controladad/ng-base';

export type TagStatusDialogData = PropertyEntity[] | LocationEntity[];

export type TagStatusDialogResult = TagStatus;

interface TagStatusRow {
  name: string;
  currentStatus: string;
  isChangable: boolean;
}

@Component({
  selector: 'app-tag-status-dialog',
  imports: [CacDialogLayoutComponent, CacControlBuilderComponent],
  templateUrl: './tag-status-dialog.component.html',
})
export class TagStatusDialogComponent extends CacBaseDialogComponent<TagStatusDialogData, TagStatusDialogResult> {
  private readonly propertyApi = inject(PropertyApiService);

  tags = signal<TagStatusRow[]>([]);
  statusControl: FormBuilderInputOption<TagStatus> = {
    label: 'وضعیت تگ',
    control: formControl<TagStatus>(TagStatus.PendingAttachment),
    type: 'select',
    items: TagStatusValues.filter(x => x.value === TagStatus.PendingAttachment || x.value === TagStatus.HasTag),
  };

  constructor() {
    super();
    this.checkValidity();

    this.statusControl.control.valueChanges.pipe(takeUntilDestroyed()).subscribe(() => {
      this.checkValidity();
    });
  }

  checkValidity() {
    const status = this.statusControl.control.value;
    const rows: TagStatusRow[] = this.data.map((x) => ({
      name: x.name,
      currentStatus: getLabel(x.tagStatus, TagStatusValues),
      isChangable: isChangingTagStatusValid(x.tagStatus, status),
    }));
    this.tags.set(rows);
  }

  onSubmit(e: ButtonClickEvent) {
    if (this.tags().some((x) => !x.isChangable)) {
      snackbar$.error('برخی از رکوردها قابل تغییر به وضعیت انتخاب شده نیستند');
      return;
    }
    this.submit(this.statusControl.control.value);
  }
}
